const BulbIcon = ({ color = "#f59e0b" }) => {
    const gradientId = "bulbGradient";

    return (
        
        <svg width="100%" height="100%" viewBox="0 0 80 120">
            <defs>
                <radialGradient id={gradientId} cx="50%" cy="40%" r="60%">
                    <stop offset="0%" stopColor={color} stopOpacity="0.9" />
                    <stop offset="45%" stopColor={color} stopOpacity="0.6" />
                    <stop offset="100%" stopColor={color} stopOpacity="0.25" />
                </radialGradient>
            </defs>

            {/* Bulb glass */}
            <ellipse
                cx="40"
                cy="40"
                rx="30"
                ry="35"
                fill={`url(#${gradientId})`}
                stroke={color}
                strokeWidth="2"
            />

            {/* Filament */}
            <line
                x1="30"
                y1="40"
                x2="50"
                y2="40"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="40"
                y1="30"
                x2="40"
                y2="50"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />

            {/* Base (static) */}
            <rect
                x="28"
                y="70"
                width="24"
                height="20"
                fill="#374151"
                stroke="#111827"
                strokeWidth="2"
                rx="3"
            />
            <rect
                x="26"
                y="90"
                width="28"
                height="10"
                fill="#4b5563"
                stroke="#111827"
                strokeWidth="1"
                rx="2"
            />
        </svg>
    );
};

export default BulbIcon;